import React from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { setBreadcrumbs } from '@/logic/breadcrumbs/actions'
import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'
import type { IWithBreadcrumbsProps } from './interfaces'

class WithBreadcrumbs extends React.PureComponent<IWithBreadcrumbsProps> {
  constructor(props: IWithBreadcrumbsProps) {
    super(props)

    if (ExecutionEnvironment.isSsr) this.setBreadcrumbs()
    else setTimeout(this.setBreadcrumbs)
  }

  componentDidUpdate(prevProps: IWithBreadcrumbsProps) {
    if (!isEqual(prevProps.breadcrumbs, this.props.breadcrumbs)) {
      this.setBreadcrumbs()
    }
  }

  componentWillUnmount() {
    this.props.setBreadcrumbs([])
  }

  setBreadcrumbs = () => {
    this.props.setBreadcrumbs(this.props.breadcrumbs)
  }

  render() {
    return null
  }
}

const mapDispatchToProps = { setBreadcrumbs }

export default connect(null, mapDispatchToProps)(WithBreadcrumbs)
